export default __webpack_public_path__ + "static/media/gallery_15.fbd99e59.jpg";